import API from 'src/api'
import { http } from '../boot/axios'

export default {
  RECORD_URL: API.GRAPHQL_URL + 'mock-location-logs',
  EXPORT_URL: API.GRAPHQL_URL + 'mock-location-logs/export',

  // Registra una deteccion de ubicacion ficticia. Organizacion e infractor los toma el back del token.
  // Va en segundo plano mientras el usuario ve el aviso de bloqueo: sin toast de conexion ni cierre
  // de sesion por un 401 que el no provoco (ver src/api/responser.js).
  record (payload) {
    return http.post(this.RECORD_URL, payload, {
      suppressConnectionToast: true,
      suppressUnauthorizedRedirect: true
    })
  },

  // Descarga directa del Excel del reporte de ubicación estricta por rango de fechas.
  // El back valida que sea admin de organización y responde con el archivo (blob).
  exportReport (payload) {
    return http.post(this.EXPORT_URL, payload, { responseType: 'blob' })
  }
}
